(function () {
  const initialized = new WeakSet();
  function initialize() {
    document.querySelectorAll('[data-bn-drawer]').forEach(drawer => {
      if (initialized.has(drawer)) return;
      const header = drawer.closest('.site-header');
      const toggle = header?.querySelector('[data-menu-toggle]');
      if (!toggle) return;
      initialized.add(drawer);
      let previousFocus;
      function close() { if (drawer.open) drawer.close(); }
      toggle.addEventListener('click', () => {
        if (drawer.open) { close(); return; }
        previousFocus = document.activeElement;
        drawer.showModal();
        toggle.setAttribute('aria-expanded','true');
        document.body.classList.add('bn-drawer-open');
        drawer.querySelector('[data-drawer-close]').focus();
      });
      drawer.querySelector('[data-drawer-close]').addEventListener('click', close);
      drawer.addEventListener('click', event => {
        const rect = drawer.getBoundingClientRect();
        if (event.target === drawer && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
        if (event.target.closest('a[href]')) close();
      });
      drawer.addEventListener('close', () => {
        toggle.setAttribute('aria-expanded','false');
        document.body.classList.remove('bn-drawer-open');
        if (previousFocus?.isConnected) previousFocus.focus();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-bn-drawer][open]')) document.body.classList.remove('bn-drawer-open');
  });
})();
